// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* src/components/ListaJogadores.css */
:root {
  --bg: #0b0d12;
  --card: #11141b;
  --card-2: #0f1218;
  --text: #e7edf6;
  --muted: #a6b0c3;
  --border: #1c2330;
  --brand: #22c55e;
  --brand-2: #16a34a;
  --danger: #ef4444;
  --info: #3b82f6;

  --radius: 16px;
  --radius-sm: 12px;
  --shadow: 0 8px 24px rgba(0,0,0,0.35);
  --shadow-soft: 0 6px 18px rgba(0,0,0,0.25);

  --gap: 16px;
  --gap-lg: 24px;
}

* { box-sizing: border-box; }
.muted { color: var(--muted); }

.lj { display: grid; gap: var(--gap-lg); }
.lj-toast {
  background: rgba(34,197,94,0.12);
  border: 1px solid rgba(34,197,94,0.25);
  color: #86efac;
  padding: 10px 12px;
  border-radius: 12px;
  font-weight: 700;
}
.lj-inline-loader { color: var(--muted); font-size: 14px; }

.lj-grid {
  display: grid;
  grid-template-columns: 1fr;
  gap: var(--gap-lg);
  min-width: 0;
}
@media (min-width: 980px) { .lj-grid--two { grid-template-columns: 1fr 1fr; } }

.card {
  background:
    radial-gradient(900px 320px at 110% -20%, rgba(34,197,94,.08), transparent),
    radial-gradient(700px 260px at -10% 115%, rgba(59,130,246,.06), transparent),
    linear-gradient(180deg, var(--card) 0%, var(--card-2) 100%);
  border: 1px solid var(--border);
  border-radius: var(--radius);
  padding: 16px;
  box-shadow: var(--shadow);
  min-width: 0;
}
.card-head {
  display: flex; align-items: center; justify-content: space-between;
  gap: 8px; margin-bottom: 10px;
}
.card-head h4 { margin: 0; font-size: 16px; font-weight: 800; }
.badge-count {
  display: inline-flex; align-items: center; justify-content: center;
  min-width: 28px; height: 22px; padding: 0 8px; border-radius: 999px;
  background: rgba(59,130,246,0.12); color: #93c5fd; border: 1px solid rgba(59,130,246,0.25);
  font-size: 12px; font-weight: 800;
}

/* Busca (apenas no card de membros) */
.search { position: relative; display: grid; align-items: center; margin-bottom: 12px; }
.search--inside { margin-top: -2px; }
.search-input {
  width: 100%;
  padding: 12px 40px;
  background: #0c0f14;
  border: 1px solid var(--border);
  border-radius: 14px;
  color: var(--text);
  outline: none;
}
.search-input::placeholder { color: #94a3b8; }
.search-input:focus { border-color: #263145; }
.search-icon { position: absolute; left: 12px; font-size: 16px; opacity: .8; }
.search-clear {
  position: absolute; right: 6px; top: 50%; transform: translateY(-50%);
  border: 0; background: transparent; color: var(--muted);
  font-size: 18px; width: 32px; height: 32px; border-radius: 999px; cursor: pointer;
}
.search-clear:hover { color: var(--text); }

/* Lista de cards */
.list { list-style: none; margin: 0; padding: 0; display: grid; gap: 12px; }

/* Card do jogador */
.pd-item {
  border: 1px solid var(--border);
  border-radius: 14px;
  background: linear-gradient(180deg, #0c0f14 0%, #0d1016 100%);
  padding: 12px;
  display: grid; gap: 10px;
  transition: transform .15s ease, box-shadow .15s ease, border-color .15s ease;
}
.pd-item:hover { transform: translateY(-1px); box-shadow: var(--shadow-soft); border-color: #243043; }

/* Cabeçalho do item: avatar + nome isolado (sem chips à direita) */
.item-head {
  display: grid;
  grid-template-columns: auto 1fr;
  gap: 10px;
  align-items: center;
  min-width: 0;
}
.pd-avatar {
  width: 34px; height: 34px; border-radius: 10px; display: grid; place-items: center;
  background: rgba(34,197,94,0.12); border: 1px solid rgba(34,197,94,0.22); color: #86efac; font-weight: 800;
}
.item-name {
  font-weight: 800;
  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;
}

/* Linha de metadados (chips) abaixo do nome */
.item-meta {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
}

/* Chips de status/tipo */
.chip {
  display: inline-flex; align-items: center; gap: 6px;
  border: 1px solid var(--border); border-radius: 999px;
  padding: 4px 8px; font-size: 12px; font-weight: 700;
  background: #0c0f14; color: var(--text);
}
.chip--ok { color: #86efac; border-color: rgba(34,197,94,0.35); background: rgba(34,197,94,0.08); }
.chip--warn { color: #facc15; border-color: rgba(250,204,21,0.35); background: rgba(250,204,21,0.08); }

/* Ações em linha inferior */
.row-actions {
  display: flex; gap: 8px; flex-wrap: wrap; justify-content: flex-end;
  border-top: 1px solid #121826;
  padding-top: 8px;
}

/* Botões discretos e compactos */
.btn-line {
  background: transparent;
  border: 1px solid var(--border);
  color: var(--text);
  padding: 4px 8px;
  border-radius: 8px;
  font-weight: 600;
  font-size: 12px;
  line-height: 1.2;
  cursor: pointer;
  transition: all .2s ease;
  white-space: nowrap;
}
.btn-line:hover { transform: translateY(-1px); box-shadow: var(--shadow-soft); }
.btn--primary-line {
  border-color: rgba(34,197,94,0.25);
  color: #86efac;
  background: rgba(34,197,94,0.08);
}
.btn--primary-line:hover { border-color: rgba(34,197,94,0.4); background: rgba(34,197,94,0.15); }
.btn--danger-line {
  border-color: rgba(239,68,68,0.25);
  color: #fca5a5;
  background: rgba(239,68,68,0.08);
}
.btn--danger-line:hover { border-color: rgba(239,68,68,0.4); background: rgba(239,68,68,0.15); }

/* Empty states */
.empty {
  border: 1px dashed var(--border);
  border-radius: 12px;
  padding: 18px;
  background: #0c0f14;
  text-align: center;
  color: var(--muted);
}
.empty-emoji { font-size: 26px; margin-bottom: 6px; }
.empty-title { font-weight: 800; color: var(--text); margin-bottom: 2px; }
.empty-sub { font-size: 13px; }

/* Footer do card (ações gerais) */
.footer-actions { margin-top: 12px; display: flex; justify-content: flex-end; }

/* Mobile refinements */
@media (max-width: 380px) {
  .search-input { padding-left: 36px; padding-right: 36px; }
  .row-actions { justify-content: stretch; }
  .btn-line { width: 100%; text-align: center; }
}
`, "",{"version":3,"sources":["webpack://./src/components/ListaJogadores.css"],"names":[],"mappings":"AAAA,sCAAsC;AACtC;EACE,aAAa;EACb,eAAe;EACf,iBAAiB;EACjB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,kBAAkB;EAClB,iBAAiB;EACjB,eAAe;;EAEf,cAAc;EACd,iBAAiB;EACjB,qCAAqC;EACrC,0CAA0C;;EAE1C,WAAW;EACX,cAAc;AAChB;;AAEA,IAAI,sBAAsB,EAAE;AAC5B,SAAS,mBAAmB,EAAE;;AAE9B,MAAM,aAAa,EAAE,kBAAkB,EAAE;AACzC;EACE,gCAAgC;EAChC,sCAAsC;EACtC,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;AAClB;AACA,oBAAoB,mBAAmB,EAAE,eAAe,EAAE;;AAE1D;EACE,aAAa;EACb,0BAA0B;EAC1B,kBAAkB;EAClB,YAAY;AACd;AACA,4BAA4B,gBAAgB,8BAA8B,EAAE,EAAE;;AAE9E;EACE;;;+DAG6D;EAC7D,+BAA+B;EAC/B,4BAA4B;EAC5B,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;AACA;EACE,aAAa,EAAE,mBAAmB,EAAE,8BAA8B;EAClE,QAAQ,EAAE,mBAAmB;AAC/B;AACA,gBAAgB,SAAS,EAAE,eAAe,EAAE,gBAAgB,EAAE;AAC9D;EACE,oBAAoB,EAAE,mBAAmB,EAAE,uBAAuB;EAClE,eAAe,EAAE,YAAY,EAAE,cAAc,EAAE,oBAAoB;EACnE,iCAAiC,EAAE,cAAc,EAAE,uCAAuC;EAC1F,eAAe,EAAE,gBAAgB;AACnC;;AAEA,sCAAsC;AACtC,UAAU,kBAAkB,EAAE,aAAa,EAAE,mBAAmB,EAAE,mBAAmB,EAAE;AACvF,kBAAkB,gBAAgB,EAAE;AACpC;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,+BAA+B;EAC/B,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;AACf;AACA,6BAA6B,cAAc,EAAE;AAC7C,sBAAsB,qBAAqB,EAAE;AAC7C,eAAe,kBAAkB,EAAE,UAAU,EAAE,eAAe,EAAE,WAAW,EAAE;AAC7E;EACE,kBAAkB,EAAE,UAAU,EAAE,QAAQ,EAAE,2BAA2B;EACrE,SAAS,EAAE,uBAAuB,EAAE,mBAAmB;EACvD,eAAe,EAAE,WAAW,EAAE,YAAY,EAAE,oBAAoB,EAAE,eAAe;AACnF;AACA,sBAAsB,kBAAkB,EAAE;;AAE1C,mBAAmB;AACnB,QAAQ,gBAAgB,EAAE,SAAS,EAAE,UAAU,EAAE,aAAa,EAAE,SAAS,EAAE;;AAE3E,oBAAoB;AACpB;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,6DAA6D;EAC7D,aAAa;EACb,aAAa,EAAE,SAAS;EACxB,6EAA6E;AAC/E;AACA,iBAAiB,2BAA2B,EAAE,8BAA8B,EAAE,qBAAqB,EAAE;;AAErG,mEAAmE;AACnE;EACE,aAAa;EACb,+BAA+B;EAC/B,SAAS;EACT,mBAAmB;EACnB,YAAY;AACd;AACA;EACE,WAAW,EAAE,YAAY,EAAE,mBAAmB,EAAE,aAAa,EAAE,mBAAmB;EAClF,gCAAgC,EAAE,sCAAsC,EAAE,cAAc,EAAE,gBAAgB;AAC5G;AACA;EACE,gBAAgB;EAChB,gBAAgB,EAAE,uBAAuB,EAAE,mBAAmB;AAChE;;AAEA,8CAA8C;AAC9C;EACE,aAAa;EACb,QAAQ;EACR,eAAe;AACjB;;AAEA,yBAAyB;AACzB;EACE,oBAAoB,EAAE,mBAAmB,EAAE,QAAQ;EACnD,+BAA+B,EAAE,oBAAoB;EACrD,gBAAgB,EAAE,eAAe,EAAE,gBAAgB;EACnD,mBAAmB,EAAE,kBAAkB;AACzC;AACA,YAAY,cAAc,EAAE,kCAAkC,EAAE,gCAAgC,EAAE;AAClG,cAAc,cAAc,EAAE,mCAAmC,EAAE,iCAAiC,EAAE;;AAEtG,4BAA4B;AAC5B;EACE,aAAa,EAAE,QAAQ,EAAE,eAAe,EAAE,yBAAyB;EACnE,6BAA6B;EAC7B,gBAAgB;AAClB;;AAEA,iCAAiC;AACjC;EACE,uBAAuB;EACvB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,wBAAwB;EACxB,mBAAmB;AACrB;AACA,kBAAkB,2BAA2B,EAAE,8BAA8B,EAAE;AAC/E;EACE,kCAAkC;EAClC,cAAc;EACd,gCAAgC;AAClC;AACA,2BAA2B,iCAAiC,EAAE,gCAAgC,EAAE;AAChG;EACE,kCAAkC;EAClC,cAAc;EACd,gCAAgC;AAClC;AACA,0BAA0B,iCAAiC,EAAE,gCAAgC,EAAE;;AAE/F,iBAAiB;AACjB;EACE,gCAAgC;EAChC,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;AACA,eAAe,eAAe,EAAE,kBAAkB,EAAE;AACpD,eAAe,gBAAgB,EAAE,kBAAkB,EAAE,kBAAkB,EAAE;AACzE,aAAa,eAAe,EAAE;;AAE9B,kCAAkC;AAClC,kBAAkB,gBAAgB,EAAE,aAAa,EAAE,yBAAyB,EAAE;;AAE9E,uBAAuB;AACvB;EACE,gBAAgB,kBAAkB,EAAE,mBAAmB,EAAE;EACzD,eAAe,wBAAwB,EAAE;EACzC,YAAY,WAAW,EAAE,kBAAkB,EAAE;AAC/C","sourcesContent":["/* src/components/ListaJogadores.css */\n:root {\n  --bg: #0b0d12;\n  --card: #11141b;\n  --card-2: #0f1218;\n  --text: #e7edf6;\n  --muted: #a6b0c3;\n  --border: #1c2330;\n  --brand: #22c55e;\n  --brand-2: #16a34a;\n  --danger: #ef4444;\n  --info: #3b82f6;\n\n  --radius: 16px;\n  --radius-sm: 12px;\n  --shadow: 0 8px 24px rgba(0,0,0,0.35);\n  --shadow-soft: 0 6px 18px rgba(0,0,0,0.25);\n\n  --gap: 16px;\n  --gap-lg: 24px;\n}\n\n* { box-sizing: border-box; }\n.muted { color: var(--muted); }\n\n.lj { display: grid; gap: var(--gap-lg); }\n.lj-toast {\n  background: rgba(34,197,94,0.12);\n  border: 1px solid rgba(34,197,94,0.25);\n  color: #86efac;\n  padding: 10px 12px;\n  border-radius: 12px;\n  font-weight: 700;\n}\n.lj-inline-loader { color: var(--muted); font-size: 14px; }\n\n.lj-grid {\n  display: grid;\n  grid-template-columns: 1fr;\n  gap: var(--gap-lg);\n  min-width: 0;\n}\n@media (min-width: 980px) { .lj-grid--two { grid-template-columns: 1fr 1fr; } }\n\n.card {\n  background:\n    radial-gradient(900px 320px at 110% -20%, rgba(34,197,94,.08), transparent),\n    radial-gradient(700px 260px at -10% 115%, rgba(59,130,246,.06), transparent),\n    linear-gradient(180deg, var(--card) 0%, var(--card-2) 100%);\n  border: 1px solid var(--border);\n  border-radius: var(--radius);\n  padding: 16px;\n  box-shadow: var(--shadow);\n  min-width: 0;\n}\n.card-head {\n  display: flex; align-items: center; justify-content: space-between;\n  gap: 8px; margin-bottom: 10px;\n}\n.card-head h4 { margin: 0; font-size: 16px; font-weight: 800; }\n.badge-count {\n  display: inline-flex; align-items: center; justify-content: center;\n  min-width: 28px; height: 22px; padding: 0 8px; border-radius: 999px;\n  background: rgba(59,130,246,0.12); color: #93c5fd; border: 1px solid rgba(59,130,246,0.25);\n  font-size: 12px; font-weight: 800;\n}\n\n/* Busca (apenas no card de membros) */\n.search { position: relative; display: grid; align-items: center; margin-bottom: 12px; }\n.search--inside { margin-top: -2px; }\n.search-input {\n  width: 100%;\n  padding: 12px 40px;\n  background: #0c0f14;\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  color: var(--text);\n  outline: none;\n}\n.search-input::placeholder { color: #94a3b8; }\n.search-input:focus { border-color: #263145; }\n.search-icon { position: absolute; left: 12px; font-size: 16px; opacity: .8; }\n.search-clear {\n  position: absolute; right: 6px; top: 50%; transform: translateY(-50%);\n  border: 0; background: transparent; color: var(--muted);\n  font-size: 18px; width: 32px; height: 32px; border-radius: 999px; cursor: pointer;\n}\n.search-clear:hover { color: var(--text); }\n\n/* Lista de cards */\n.list { list-style: none; margin: 0; padding: 0; display: grid; gap: 12px; }\n\n/* Card do jogador */\n.pd-item {\n  border: 1px solid var(--border);\n  border-radius: 14px;\n  background: linear-gradient(180deg, #0c0f14 0%, #0d1016 100%);\n  padding: 12px;\n  display: grid; gap: 10px;\n  transition: transform .15s ease, box-shadow .15s ease, border-color .15s ease;\n}\n.pd-item:hover { transform: translateY(-1px); box-shadow: var(--shadow-soft); border-color: #243043; }\n\n/* Cabeçalho do item: avatar + nome isolado (sem chips à direita) */\n.item-head {\n  display: grid;\n  grid-template-columns: auto 1fr;\n  gap: 10px;\n  align-items: center;\n  min-width: 0;\n}\n.pd-avatar {\n  width: 34px; height: 34px; border-radius: 10px; display: grid; place-items: center;\n  background: rgba(34,197,94,0.12); border: 1px solid rgba(34,197,94,0.22); color: #86efac; font-weight: 800;\n}\n.item-name {\n  font-weight: 800;\n  overflow: hidden; text-overflow: ellipsis; white-space: nowrap;\n}\n\n/* Linha de metadados (chips) abaixo do nome */\n.item-meta {\n  display: flex;\n  gap: 6px;\n  flex-wrap: wrap;\n}\n\n/* Chips de status/tipo */\n.chip {\n  display: inline-flex; align-items: center; gap: 6px;\n  border: 1px solid var(--border); border-radius: 999px;\n  padding: 4px 8px; font-size: 12px; font-weight: 700;\n  background: #0c0f14; color: var(--text);\n}\n.chip--ok { color: #86efac; border-color: rgba(34,197,94,0.35); background: rgba(34,197,94,0.08); }\n.chip--warn { color: #facc15; border-color: rgba(250,204,21,0.35); background: rgba(250,204,21,0.08); }\n\n/* Ações em linha inferior */\n.row-actions {\n  display: flex; gap: 8px; flex-wrap: wrap; justify-content: flex-end;\n  border-top: 1px solid #121826;\n  padding-top: 8px;\n}\n\n/* Botões discretos e compactos */\n.btn-line {\n  background: transparent;\n  border: 1px solid var(--border);\n  color: var(--text);\n  padding: 4px 8px;\n  border-radius: 8px;\n  font-weight: 600;\n  font-size: 12px;\n  line-height: 1.2;\n  cursor: pointer;\n  transition: all .2s ease;\n  white-space: nowrap;\n}\n.btn-line:hover { transform: translateY(-1px); box-shadow: var(--shadow-soft); }\n.btn--primary-line {\n  border-color: rgba(34,197,94,0.25);\n  color: #86efac;\n  background: rgba(34,197,94,0.08);\n}\n.btn--primary-line:hover { border-color: rgba(34,197,94,0.4); background: rgba(34,197,94,0.15); }\n.btn--danger-line {\n  border-color: rgba(239,68,68,0.25);\n  color: #fca5a5;\n  background: rgba(239,68,68,0.08);\n}\n.btn--danger-line:hover { border-color: rgba(239,68,68,0.4); background: rgba(239,68,68,0.15); }\n\n/* Empty states */\n.empty {\n  border: 1px dashed var(--border);\n  border-radius: 12px;\n  padding: 18px;\n  background: #0c0f14;\n  text-align: center;\n  color: var(--muted);\n}\n.empty-emoji { font-size: 26px; margin-bottom: 6px; }\n.empty-title { font-weight: 800; color: var(--text); margin-bottom: 2px; }\n.empty-sub { font-size: 13px; }\n\n/* Footer do card (ações gerais) */\n.footer-actions { margin-top: 12px; display: flex; justify-content: flex-end; }\n\n/* Mobile refinements */\n@media (max-width: 380px) {\n  .search-input { padding-left: 36px; padding-right: 36px; }\n  .row-actions { justify-content: stretch; }\n  .btn-line { width: 100%; text-align: center; }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
